module.exports = __webpack_public_path__ + "static/media/desk-icon.81bc31df.svg";